import React, { useState, useEffect } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Label } from "recharts";

import { useApiGateway } from 'hooks/useApi';

import { UpdownGradeConsensus, UPGRADE_DOWNGRADE_CONSENSUS_API } from 'constants/stockApi';

interface ChartData {
  name: string;
  value: number;
  color: string;
}

export const BuyingRating: React.FC<{
  ticker: string;
}> = ({ ticker }) => {
  const { get: fetchUpgradeDownData, isLoading } = useApiGateway(UPGRADE_DOWNGRADE_CONSENSUS_API(ticker));

  const [updownGrade, setUpdownGrade] = useState<UpdownGradeConsensus[] | null>(null);
  const [chartData, setChartData] = useState<ChartData[]>([]);

  useEffect(() => {
    if (!ticker) return;

    (async function () {
      try {
        const resp = await fetchUpgradeDownData();
        setUpdownGrade(resp?.data || []);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [ticker]);

  useEffect(() => {
    if (updownGrade && updownGrade.length > 0) {
      const { buy, hold, sell, strongBuy, strongSell } = updownGrade[0];

      const transformedData: ChartData[] = [
        { name: "Sell", value: Number(sell + strongSell), color: "#f04662" },
        { name: "Hold", value: hold, color: "#ffc045" },
        { name: "Buy", value: Number(buy + strongBuy), color: "#6be594" },
      ];

      setChartData(transformedData);
    } else {
      setChartData([]);
    }
  }, [updownGrade, ticker]);

  return (
    <>
      {!isLoading && chartData?.length > 0 && (
        <div className="overflow-hidden w-full h-full">
          <ResponsiveContainer width="100%" height={150}>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="100%"
                startAngle={180}
                endAngle={0}
                innerRadius={95}
                outerRadius={130}
                paddingAngle={0}
                dataKey="value"
                stroke="none"
                labelLine={false}
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
                <Label
                  value="BUY"
                  position="center"
                  style={{
                    fontSize: "30px",
                    fill: "#FFFFFF",
                    transform: "translateY(-40px)",
                  }}
                />
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <div className="flex justify-around text-white mt-3 p-2 rounded">
            {chartData.map((entry) => (
              <div className="text-center" key={entry.name}>
                <div style={{ color: entry.color }}>{entry.name}</div>
                <div className="text-lg" style={{ color: entry.color }}>{entry.value}</div>
              </div>
            ))}
          </div>
        </div>
      )
      }
    </>
  );
};
